import React, { Component } from 'react';
import './css/Note.css';
import Navbar from './Navbar.js'
import Note from './Note.js'
import Account from './Account.js'
import DB from '../db.js'
import firebase from '../Firebase.js'
import {
	Route,
	Redirect
} from 'react-router-dom';
import {withRouter} from 'react-router';
var moment = require('moment');


class Portal extends Component {

	constructor(props) {
		
		super(props);

		if(!("state" in props.location) || !props.location.state)
			props.location.state = {}

		this.state = {
			"data": {
				1: { "task": [] },
				2: { "task": [] },
				3: {},
				4: {}
			},
			"filter": {
				"week": props.location.state.week || moment().week(),
				"year": props.location.state.year || moment().year(),
				"uid": props.location.state.uid || null
			},
			"searchResult": null
		};

		
		// Bind Allow access by "this" into the function
		this.filter = this.filter.bind(this);
		this.weekNbr = this.weekNbr.bind(this);
		this.loadDataFromDb = this.loadDataFromDb.bind(this);

	}

	
	componentDidMount(){
		if(this.props.location.state)
		this.state.filter = this.props.location.state
		
		// Listen for changes to the current location.
		const unlisten = this.props.history.listen((location, action) => {
			// location is an object like window.location
			
			if(location.state)
				this.setState(Object.assign(this.state, {"filter": location.state}))

			if(this.props.history.location.pathname.indexOf("/note") === 0)
				this.loadDataFromDb()
		})
		
	}
	
	filter(obj){
		if(typeof obj === "object" || obj === false){
			if(obj === false)
				obj = {"week": moment().week()}

			let argsUrl = "",
				order = ["year", "week", "uid"], // Order in the URL,
				onlyForUser = [order[1]],
				uid = this.props.getUser().uid
			
			order.forEach(type => {
				if(type in obj && obj[type])
					if(DB.adminUid.indexOf(uid) >= 0 || onlyForUser.indexOf(type) >= 0)
						argsUrl += obj[type]+"/"
			});
			
			this.props.history.push("/note/"+argsUrl, obj) // We don't use the params from here, ony by "state"
		}else
			return this.state.filter? this.state.filter : null
	}

	weekNbr(obj){
			return "week" in this.state.filter? this.state.filter.week : null
	}

	loadDataFromDb(e){
		let self = this

		console.info('Call google');
		
		DB.init(firebase).getLogedUserWhenReady((user, DB) => {
			if(user)
				DB.load("Notes/"+(this.state.filter.uid||this.props.getUser().uid)+"/"+(this.state.filter.year||moment().year())+"/"+(this.state.filter.week||moment().week()), {once: true, orderByKey: true}, (data) => {
					let d = data.val(),
						dataOut = {}

					if(d){
						for (const key in d) {
							if (d.hasOwnProperty(key)) {
								const day = d[key];

								if(!dataOut[day.dayNbr])
									dataOut[day.dayNbr] = {};

								if(!("task" in dataOut[day.dayNbr]))
								dataOut[day.dayNbr] = {task: []};
								
								dataOut[day.dayNbr].task.push(Object.assign(day, {id: key}))
							}
						}
					}
					self.setState(Object.assign(self.state, {"data": dataOut}))
				})
		})
	}


	render() {
		if(this.props.mustShow)
			return (
				<div>
					<Navbar history={this.props.history} filter={this.filter} getUser={this.props.getUser} users={this.users}></Navbar>
					<Route history={this.props.history} exact path="/" render={()=><Redirect to="/note"/>}/>
					<Route history={this.props.history}
						path="/note/:year?/:week?/:uid?"
						render={(props)=><Note
										props={props} // Pass props from Route to our rendered componant
										mustShow={this.props.getUser()? true : false} 
										getUser={this.props.getUser} 
										users={this.props.users} 
										data={this.state.data} 
										filter={this.filter}>
									</Note>} />
					<Route history={this.props.history} path="/account/:uid?" render={(props)=><Account
										props={props} // Pass props from Route to our rendered componant
										filter={this.filter}
										getUser={this.props.getUser} 
										users={this.props.users}>
									</Account>} />
				</div>
			);
		else
			return ("");
	}
}

export default withRouter(Portal)



// WEBPACK FOOTER //
// ./src/Pages/Portal.js